import React from 'react';

const HeroSection: React.FC = () => {
  return (
    <section className="relative overflow-hidden w-full">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            "linear-gradient(90deg, rgba(11,31,62,0.42) 0%, rgba(22,52,100,0.34) 50%, rgba(10,28,58,0.44) 100%), linear-gradient(0deg, rgba(10,31,70,0.38), rgba(10,31,70,0.38)), url('/images/miningreporthero.webp')",
          backgroundSize: 'cover, cover, cover',
          backgroundRepeat: 'no-repeat, no-repeat, no-repeat',
          backgroundPosition: 'center 72%, center 72%, center 72%'
        }}
      />

      <div className="relative z-10 max-w-[1250px] mx-auto px-6 py-8 md:py-11 text-white text-center">
        <h1 className="font-[700] text-[31px] md:text-[31px] leading-[35px] md:leading-[35px] tracking-[0.03em]">
          Gold to $10,000?
          <br className="md:hidden" />
          {' '}Copper to the Moon?
        </h1>
        <h2 className="font-[700] text-[31px] md:text-[31px] leading-[35px] md:leading-[35px] tracking-[0.03em] mt-5 md:mt-7">
          The 2025 Mining
          <br className="md:hidden" />
          Explosion Is Just
          <br className="md:hidden" />
          Getting Started
        </h2>

        <ul className="mt-6 md:mt-8 text-left max-w-[760px] md:max-w-[700px] mx-auto text-[18px] md:text-[18px] leading-[18px] md:leading-[18px] tracking-[0.03em] font-[400] list-disc pl-6 md:pl-6 space-y-4 md:space-y-4 break-words">
          <li>Gold ETFs +145% in a single year.</li>
          <li>Select juniors up 300-800%.</li>
          <li>The super-cycle didn’t end in 2025 — it’s accelerating into 2026.</li>
        </ul>

        <p className="mt-6 md:mt-8 text-[18px] md:text-[18px] leading-[29px] md:leading-[29px] tracking-[0.03em] text-center max-w-[820px] mx-auto break-words">
          <span className="font-[700]">Get the full report that serious investors are already using to ride</span>
          <br className="hidden md:block" />
          <span className="font-[700]">this wave</span>{' '}
          <span className="font-[400]">(and avoid the wipeouts).</span>
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
